import React from "react";
import { Route } from "react-router-dom";
import AuditorDashboard from "../../screens/auditor/AuditorDashboard";

export const auditorRoutes = [
  <Route key="auditor-home" path="/" element={<AuditorDashboard />} />,
];
